import { useMemo } from 'react';
import { useValidationResults } from '../../../../../contexts/selectors/useValidationResults';

export const useShowValidationBanner = () => {
  const validationResults = useValidationResults();

  return useMemo(() => !!validationResults.length, [validationResults.length]);
};
